import { useContext } from "react";
import { WPRContext } from "../WPRContextProvider";

export const useWPRContext = () => {
  const values = useContext(WPRContext);

  return values;
};
